"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContactInfoEnum = exports.ContactCourierCard = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _reactSvg = require("react-svg");
var _shopeeCommon = require("@mkt-common/shopee-common");
var _ButtonGroup = require("../ButtonGroup");
var _Button = require("../Button");
var _Popup = require("../Popup");
var _copy = _interopRequireDefault(require("../../assets/images/copy.svg"));
var _contact_courier_call = _interopRequireDefault(require("../../assets/images/contact_courier_call.svg"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _LocaleProvider = require("../LocaleProvider");
var _context = require("../ConfigProvider/context");
var _types = require("../../types");
var _useTracking = require("../../hooks/useTracking");
var _constants = require("../../utils/constants");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var ContactInfoEnum;
exports.ContactInfoEnum = ContactInfoEnum;
(function (ContactInfoEnum) {
  ContactInfoEnum["Email"] = "email";
  ContactInfoEnum["WhatsApp"] = "whatsapp";
  ContactInfoEnum["Facebook"] = "facebook";
  ContactInfoEnum["Call"] = "call";
  ContactInfoEnum["Line"] = "line";
})(ContactInfoEnum || (exports.ContactInfoEnum = ContactInfoEnum = {}));
var ContactCourierCard = function ContactCourierCard(props) {
  var _ContactInfoText, _driverInfo$milestone;
  var trackLinks = props.trackLinks,
    _props$contactsInfo = props.contactsInfo,
    contactsInfo = _props$contactsInfo === void 0 ? [] : _props$contactsInfo,
    driverInfo = props.driverInfo,
    logoImg = props.logoImg,
    courierTitle = props.courierTitle,
    orderInfo = props.orderInfo,
    operateTime = props.operateTime,
    handleCopyClick = props.handleCopyClick,
    showDriverInfo = props.showDriverInfo,
    _props$componentTrack = props.componentTrackingData,
    componentTrackingData = _props$componentTrack === void 0 ? {} : _props$componentTrack;
  var context = (0, _react.useContext)(_context.ConfigContext);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    active = _useState2[0],
    setActive = _useState2[1];
  var _useLocale = (0, _LocaleProvider.useLocale)(),
    trans = _useLocale.trans;
  var ContactInfoText = (_ContactInfoText = {}, (0, _defineProperty2.default)(_ContactInfoText, ContactInfoEnum.Email, trans(_constants.CONTACT_COURIER_CARD.EMAIL)), (0, _defineProperty2.default)(_ContactInfoText, ContactInfoEnum.WhatsApp, trans(_constants.CONTACT_COURIER_CARD.WHATS_APP)), (0, _defineProperty2.default)(_ContactInfoText, ContactInfoEnum.Facebook, trans(_constants.CONTACT_COURIER_CARD.FACEBOOK)), (0, _defineProperty2.default)(_ContactInfoText, ContactInfoEnum.Call, trans(_constants.CONTACT_COURIER_CARD.CALL)), (0, _defineProperty2.default)(_ContactInfoText, ContactInfoEnum.Line, trans(_constants.CONTACT_COURIER_CARD.LINE) || 'Line'), _ContactInfoText);
  var defaultButtonProps = {
    type: 'secondary-outlined',
    className: (0, _getPrefixCls.getPrefixCls)('contact-courier-card-content-button') // style: {  }, // minWidth: '5.375rem'
  };

  var handleTrack = function handleTrack() {
    if ((trackLinks === null || trackLinks === void 0 ? void 0 : trackLinks.length) === 1) {
      var _context$eventEmitter, _context$eventEmitter2, _trackLinks$;
      context === null || context === void 0 ? void 0 : (_context$eventEmitter = context.eventEmitter) === null || _context$eventEmitter === void 0 ? void 0 : (_context$eventEmitter2 = _context$eventEmitter.emit) === null || _context$eventEmitter2 === void 0 ? void 0 : _context$eventEmitter2.call(_context$eventEmitter, _types.ButtonEvents.Redirection, {
        text: '',
        action: {
          url_info: {
            url: trackLinks === null || trackLinks === void 0 ? void 0 : (_trackLinks$ = trackLinks[0]) === null || _trackLinks$ === void 0 ? void 0 : _trackLinks$.url
          }
        }
      });
    } else {
      setActive(true);
    }
  };
  var _useComponentTracking = (0, _useTracking.useComponentTracking)(props),
    tracker = _useComponentTracking.tracker,
    _useComponentTracking2 = _useComponentTracking.result,
    ContactCourierCardButton_trackOrder = _useComponentTracking2.ContactCourierCardButton_trackOrder,
    ContactCourierCardCallDriver_driverCall = _useComponentTracking2.ContactCourierCardCallDriver_driverCall,
    ContactCourierCardCopyPaste_copy = _useComponentTracking2.ContactCourierCardCopyPaste_copy;
  var buttons = (0, _react.useMemo)(function () {
    var ContactCourierCardButton_call = componentTrackingData.ContactCourierCardButton_call,
      ContactCourierCardButton_facebook = componentTrackingData.ContactCourierCardButton_facebook,
      ContactCourierCardButton_whatsapp = componentTrackingData.ContactCourierCardButton_whatsapp,
      ContactCourierCardButton_email = componentTrackingData.ContactCourierCardButton_email;
    return contactsInfo === null || contactsInfo === void 0 ? void 0 : contactsInfo.map(function (v, i) {
      var trackingData = {};
      if (v.action === ContactInfoEnum.Email) {
        trackingData = ContactCourierCardButton_email;
      } else if (v.action === ContactInfoEnum.Call) {
        trackingData = ContactCourierCardButton_call;
      } else if (v.action === ContactInfoEnum.Facebook) {
        trackingData = ContactCourierCardButton_facebook;
      } else if (v.action === ContactInfoEnum.WhatsApp) {
        trackingData = ContactCourierCardButton_whatsapp;
      }
      var defaultProps = _objectSpread(_objectSpread({}, defaultButtonProps), {}, {
        style: {
          flex: 1,
          marginLeft: i === 0 ? 0 : '0.5rem'
        }
      });
      if (v.action === ContactInfoEnum.Email || v.action === ContactInfoEnum.Call) {
        var protocol = v.action === ContactInfoEnum.Email ? 'mailto:' : 'tel:';
        return _objectSpread(_objectSpread({}, defaultProps), {}, {
          trackingData: trackingData,
          text: ContactInfoText[v.action],
          children: /*#__PURE__*/_react.default.createElement("a", {
            href: "".concat(protocol).concat(v.information)
          }, ContactInfoText[v.action]),
          className: (0, _clsx.default)(defaultButtonProps.className, (0, _getPrefixCls.getPrefixCls)('contact-courier-card-content-button-link'))
        });
      }
      return _objectSpread(_objectSpread({}, defaultProps), {}, {
        trackingData: trackingData,
        text: ContactInfoText[v.action],
        action: {
          func: _types.ButtonEvents.OpenExternalLink,
          url_info: {
            url: v.information
          }
        }
      });
    });
  }, [contactsInfo, componentTrackingData]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('contact-courier-card'))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('contact-courier-card-header'))
  }, logoImg ? /*#__PURE__*/_react.default.createElement("img", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('contact-courier-card-header-pic')),
    src: logoImg.startsWith('https://') || logoImg.startsWith('http://') ? logoImg : "data:image/png;base64, ".concat(logoImg),
    alt: ""
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('contact-courier-card-header-pic'))
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('contact-courier-card-header-title'))
  }, courierTitle)), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('contact-courier-card-content'))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('contact-courier-card-content-top'))
  }, orderInfo !== null && orderInfo !== void 0 && orderInfo.image ? /*#__PURE__*/_react.default.createElement("img", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('contact-courier-card-content-top-pic')),
    src: (0, _shopeeCommon.cdnFile)(orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.image),
    alt: ""
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('contact-courier-card-content-top-pic')),
    style: {
      border: 'none'
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('contact-courier-card-content-top-order'))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('contact-courier-card-content-top-order-text'))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('contact-courier-card-content-top-order-text-copy'))
  }, orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.shipping_trace_no), (orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.shipping_trace_no) && /*#__PURE__*/_react.default.createElement("div", ContactCourierCardCopyPaste_copy === null || ContactCourierCardCopyPaste_copy === void 0 ? void 0 : ContactCourierCardCopyPaste_copy.trackingImpressionProps, /*#__PURE__*/_react.default.createElement(_reactSvg.ReactSVG, {
    src: _copy.default,
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('contact-courier-card-content-top-order-text-icon')),
    onClick: function onClick() {
      handleCopyClick === null || handleCopyClick === void 0 ? void 0 : handleCopyClick(orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.shipping_trace_no); // toast.show('Tracking number copied', 'success');

      (ContactCourierCardCopyPaste_copy === null || ContactCourierCardCopyPaste_copy === void 0 ? void 0 : ContactCourierCardCopyPaste_copy.trackingClick) && tracker.click(ContactCourierCardCopyPaste_copy.trackingClick);
    }
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('contact-courier-card-content-top-order-status'))
  }, trans((_driverInfo$milestone = driverInfo === null || driverInfo === void 0 ? void 0 : driverInfo.milestone_key) !== null && _driverInfo$milestone !== void 0 ? _driverInfo$milestone : ' '))), /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('contact-courier-card-content-top-track')),
    onClick: function onClick() {
      handleTrack(); // handleCopyClick?.(orderInfo?.shipping_trace_no); // 根据产品要求隐藏掉

      (ContactCourierCardButton_trackOrder === null || ContactCourierCardButton_trackOrder === void 0 ? void 0 : ContactCourierCardButton_trackOrder.trackingClick) && tracker.click(ContactCourierCardButton_trackOrder.trackingClick);
    }
  }, ContactCourierCardButton_trackOrder === null || ContactCourierCardButton_trackOrder === void 0 ? void 0 : ContactCourierCardButton_trackOrder.trackingImpressionProps), trans(_constants.CONTACT_COURIER_CARD.TRACK_ORDER))), showDriverInfo && (driverInfo === null || driverInfo === void 0 ? void 0 : driverInfo.driver_name) && (driverInfo === null || driverInfo === void 0 ? void 0 : driverInfo.driver_phone) && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('contact-courier-card-content-center'))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('contact-courier-card-content-center-left'))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('contact-courier-card-content-center-left-name'))
  }, trans(_constants.CONTACT_COURIER_CARD.DRIVER), ": ", driverInfo === null || driverInfo === void 0 ? void 0 : driverInfo.driver_name), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('contact-courier-card-content-center-left-tip'))
  }, trans(_constants.CONTACT_COURIER_CARD.YOU_CAN_CONNECT_DRIVER))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('contact-courier-card-content-center-right'))
  }, /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({
    href: "tel:".concat(driverInfo === null || driverInfo === void 0 ? void 0 : driverInfo.driver_phone),
    onClick: function onClick() {
      (ContactCourierCardCallDriver_driverCall === null || ContactCourierCardCallDriver_driverCall === void 0 ? void 0 : ContactCourierCardCallDriver_driverCall.trackingClick) && tracker.click(ContactCourierCardCallDriver_driverCall.trackingClick);
    }
  }, ContactCourierCardCallDriver_driverCall === null || ContactCourierCardCallDriver_driverCall === void 0 ? void 0 : ContactCourierCardCallDriver_driverCall.trackingImpressionProps), /*#__PURE__*/_react.default.createElement(_reactSvg.ReactSVG, {
    src: _contact_courier_call.default,
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('contact-courier-card-content-center-right-call'))
  })))), operateTime !== null && operateTime !== void 0 && operateTime.length || contactsInfo !== null && contactsInfo !== void 0 && contactsInfo.length ? /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('contact-courier-card-content-bottom'))
  }, contactsInfo !== null && contactsInfo !== void 0 && contactsInfo.length ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, trans(_constants.CONTACT_COURIER_CARD.CONTACT_COURIER_ANY_QUESTION), /*#__PURE__*/_react.default.createElement("br", null)) : null, operateTime !== null && operateTime !== void 0 && operateTime.length && contactsInfo !== null && contactsInfo !== void 0 && contactsInfo.length ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, trans(_constants.CONTACT_COURIER_CARD.OPERATION_HOURS), ":", ' ', operateTime.map(function (v, i) {
    var _v$working_day, _v$working_day2, _v$working_day3, _v$working_hour, _v$working_hour2;
    return "".concat(i !== 0 ? ', ' : '').concat(v === null || v === void 0 ? void 0 : (_v$working_day = v.working_day) === null || _v$working_day === void 0 ? void 0 : _v$working_day.start, " ").concat(v !== null && v !== void 0 && (_v$working_day2 = v.working_day) !== null && _v$working_day2 !== void 0 && _v$working_day2.end ? '- ' + (v === null || v === void 0 ? void 0 : (_v$working_day3 = v.working_day) === null || _v$working_day3 === void 0 ? void 0 : _v$working_day3.end) : '', " (").concat(v === null || v === void 0 ? void 0 : (_v$working_hour = v.working_hour) === null || _v$working_hour === void 0 ? void 0 : _v$working_hour.start, " - ").concat(v === null || v === void 0 ? void 0 : (_v$working_hour2 = v.working_hour) === null || _v$working_hour2 === void 0 ? void 0 : _v$working_hour2.end, ")");
  })) : null) : null, /*#__PURE__*/_react.default.createElement(_ButtonGroup.ButtonGroup, {
    layout: "horizontal",
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('contact-courier-card-content-buttons')),
    buttons: buttons
  })), /*#__PURE__*/_react.default.createElement(_Popup.Popup, {
    active: active,
    onClose: function onClose() {
      return setActive(false);
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('contact-courier-card-popup'))
  }, trackLinks.map(function (v, i) {
    return /*#__PURE__*/_react.default.createElement(_Button.Button, {
      className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('contact-courier-card-popup-link')),
      action: {
        func: _types.ButtonEvents.Redirection,
        url_info: {
          url: v.url
        }
      },
      text: v.url,
      type: "link",
      key: i
    });
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('contact-courier-card-popup-gap'))
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('contact-courier-card-popup-cancel')),
    onClick: function onClick() {
      return setActive(false);
    }
  }, trans(_constants.CONTACT_COURIER_CARD.CANCEL) || 'Cancel'))));
};
exports.ContactCourierCard = ContactCourierCard;